import { Box, Container } from "@mui/material";
import React from "react";
import { Trading } from "../../CommonPage/MarketFlow/Trading";
import GlobalAssets from "../../Componenets/Globalassets/GlobalAssets";
import WhyTradeForex from "../../CommonPage/WhyTradeForexs/WhyTradeForex";
import { PickPairs } from "../../CommonPage/PickPair/PickPairs";
import Wealth from "../../Componenets/Globalassets/Wealth";
import NewWealth from "../../Componenets/Globalassets/NewWealth";
import { useLanguage } from "../../context/LanguageContext";
import GlobalForex from "../../Componenets/Globalassets/GlobalForex";

export const TradingPage = () => {
  const { language, translations } = useLanguage();


  const cardData = [
    {
      heading:translations[language]?.cardsDataeEn?.title1,
      logo: "/Images/245.png",
      description:translations[language]?.cardsDataeEn?.description1,
    },
    {
      heading:translations[language]?.cardsDataeEn?.title2,
      logo: "/Images/music.png",
      description:translations[language]?.cardsDataeEn?.description2,

    },
    {
      heading:translations[language]?.cardsDataeEn?.title3,
      logo: "/Images/search.png",
      description:translations[language]?.cardsDataeEn?.description3,
    },
    {
      heading:translations[language]?.cardsDataeEn?.title4,
      logo: "/Images/no.png",
      description:translations[language]?.cardsDataeEn?.description4,
    },
  ];


  return (
    <Box>
      <Trading banner="https://res.cloudinary.com/dk24unkwu/image/upload/v1753695154/forexClean1_i3fknj.png" titleLine1={translations[language]?.tradingNew?.titleLine1} titleLine2={translations[language]?.tradingNew?.titleLine2} active={translations[language]?.tradingNew?.active} subtitle={translations[language]?.tradingNew?.subtitle} />
      <GlobalForex />
      <WhyTradeForex  cardData={cardData}/>
      <PickPairs title={translations[language]?.PickData} subtitle={translations[language]?.picDec} />
      
        <Box mt={10} mx={3}>
          <NewWealth />
        </Box>
     
    </Box>
  );
};
